import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export function AbstractLogo(t0) {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="m.825 16.11 6.573-1.76.004-.004 3.8-6.584-1.759-6.577-3.088.826 1.76 6.577c.15.563.075 1.152-.218 1.655a2.162 2.162 0 0 1-1.324 1.017L0 13.02l.825 3.09ZM16.602 14.35l6.573 1.76.825-3.09-6.573-1.76a2.162 2.162 0 0 1-1.324-1.017 2.164 2.164 0 0 1-.218-1.655l1.76-6.577-3.088-.826-1.76 6.577 3.8 6.584.005.004ZM15.799 15.738l4.813 4.817-2.258 2.26-4.814-4.817a2.158 2.158 0 0 0-1.542-.638c-.585 0-1.13.225-1.542.638l-4.813 4.816-2.259-2.26 4.814-4.816h7.6Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}